// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4607":"db16ed24","7199":"db16ed24","7252":"db16ed24","9097":"a6e99903","9457":"db16ed24"}[chunkId] + ".chunk.css";
};